import { RouteComponentProps } from "@reach/router";
import { useStore } from "app/contexts/store-context";
import TextEditor from "app/main/text-editor";

const Interests = (props: RouteComponentProps): JSX.Element => {
  const {
    state: { resume },
    dispatch
  } = useStore();

  const handleChange = (text: string) => {
    dispatch({
      type: "resume",
      payload: {
        ...resume,
        interests: text
      }
    });
  };

  return (
    <div className="space-y-5">
      <TextEditor value={resume?.interests} onChange={handleChange} />
    </div>
  );
};

export default Interests;
